<template>
  <div>
    <page-title v-if="pageTitle">
      {{ $t(pageTitle) }}
    </page-title>

    <form :class="formClass" :ref="formRef" @submit="onSubmit">
      <slot></slot>

      <div class="submitForm centered-button">
        <submit-button  v-if="defaultSubmitButton" @click="onClickSubmit" />
      </div>
    </form>
    <traveller-existing v-if="modalExisting" v-bind:params-existing="paramsExisting" @ok="confirmExisting" @cancel="cancelExisting"/>
  </div>
</template>

<script>
import pageTitle from '@/components/frontoffice/pageTitle'
import submitButton from '@/components/frontoffice/form/baseInput/submit'
import FormSubmitter from '@/api/formSubmitter'
import travellerExisting from '@/components/frontoffice/form/traveller/existingTravellerModal'

export default {
  components: {
    pageTitle,
    submitButton,
    travellerExisting
  },

  props: {
    type: {
      type: String,
      required: true
    },
    pageTitle: String,
    formData: {
      type: Object,
      required: true
    },
    displayGrid: {
      type: Boolean,
      default: false
    },
    defaultSubmitButton: {
      type: Boolean,
      default: true
    },
    callbacks: {
      onAutonomously: Function,
      onWithAgent: Function,
      addTraveller: Function,
      editTraveller: Function,
      massEditContingents: Function
    },
    formRef: {
      type: String,
      default: ''
    },
    submitCallbacks: Function,
    unloggedInfos: Object,
    invokedSubmitButtonName: String,
    disabledSubmitButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      codeExistingParams: 115,
      paramsExisting: [],
      modalExisting: this.type === 'traveller_add' || this.type === 'traveller_edit',
    }
  },

  created () {
    if (this.displayGrid) {
      for (let slot of this.$slots.default) {
        if (slot.componentOptions) {
          slot.componentOptions.propsData.displayGrid = true
        }
      }
    }
  },

  methods: {
    onSubmit (event) {
      this.$emit('submit')
      if (this.disabledSubmitButton) return
      event.preventDefault()

      if (!this.submitCallbacks) {
        let invokedSubmitButtonName = ''

        // Detect which button is clicked
        if (event.explicitOriginalTarget && event.explicitOriginalTarget.name) {
          // works only on FF
          invokedSubmitButtonName = event.explicitOriginalTarget.name
        } else if (event.srcElement.invokedSubmitButtonName) {
          invokedSubmitButtonName = event.srcElement.invokedSubmitButtonName.value
        } else {
          invokedSubmitButtonName = this.invokedSubmitButtonName
        }

        this.dataSubmit(invokedSubmitButtonName)
      } else {
        this.submitCallbacks(event, this.formData)
      }
    },

    onClickSubmit (event) {
      // event.currentTarget.addClass('clicked')
      this.invokedSubmitButtonName = event.currentTarget.name
    },

    dataSubmit (invokedSubmitButtonName) {
      this.cleanErrors()

      // Priority to Hotel, then Location, then destination
      if (['autonomously', 'with-agent'].indexOf(invokedSubmitButtonName) !== -1) {
        // if hotel is set, location is set as well
        if (this.formData.favorite.location !== null) this.formData.destination = null
      }

      let secondArg = null

      if ((this.type === 'traveller_add' || this.type === 'traveller_edit') && this.unloggedInfos) {
        secondArg = this.unloggedInfos.companyUniqueChain
      }

      if (this.type === 'home_research') secondArg = invokedSubmitButtonName === 'with-agent'

      let submitter = new FormSubmitter(this.type)
      submitter.submitRequest(this.formData, secondArg)
        .then(response => {
          if (response['data']['success']) {
            this.dealSuccess(invokedSubmitButtonName, response['data']['data'])
          } else {
            this.dealFailure(response['data']['errors'])
          }
        }).catch(response => {
          this.dealFailure(response['data']['errors'])
        })
    },

    cleanErrors () {
      for (let index in this.formData) {
        if (this.formData.hasOwnProperty(index)) {
          if (this.$parent.$refs[index]) {
            this.$parent.$refs[index].hideErrors()
          }
        }
      }
    },

    dealSuccess (submitButtonName, data = {}) {
      this.$emit('success')
      this.cleanErrors()
      if (this.callbacks[submitButtonName]) {
        this.callbacks[submitButtonName](data)
      }
    },

    dealFailure (response) {
      this.$emit('failure')
      let managedErrors = []
      let errors = []

      for (let fields in response) {
        if (response.hasOwnProperty(fields)) {
          let code = parseInt(response[fields])
          let message = this.$i18n.t('error.' + code)
          let listFields = []

          if (fields.indexOf(',') !== -1) {
            listFields = fields.split(',')
          } else {
            listFields = [fields]
          }

          if (code === this.codeExistingParams) {
            if (!this.paramsExisting.includes(fields)) this.paramsExisting.push(fields)
          } else {
            try {
              for (let field of listFields) {
                if (managedErrors.indexOf(field) === -1) {
                  this.$parent.$parent.$refs[field].setErrorVisible(message)
                  managedErrors.push(field)
                }
              }
            } catch (e) {
              for (let field of listFields) {
                if (managedErrors.indexOf(field) === -1) {
                  errors.push({
                    code: code,
                    field: field,
                    msg: message
                  })
                  managedErrors.push(field)
                }
              }
            }
          }
        }
      }

      if (this.paramsExisting) {
        this.$bvModal.show('traveller-existing')
      }
      this.$emit('error', errors)

      for (let index in this.formData) {
        if (this.formData.hasOwnProperty(index)) {
          if (managedErrors.indexOf(index) === -1) {
            if (index in this.$parent.$parent.$refs) { this.$parent.$parent.$refs[index].hideErrors() }
          }
        }
      }
    },

    confirmExisting () {
      this.formData.validForm = true
      this.onSubmit(event)
      this.paramsExisting = []
    },

    cancelExisting () {
      this.formData.validForm = false
      this.paramsExisting = []
    }
  },

  computed: {
    formClass () {
      return this.displayGrid ? 'grid' : ''
    }
  }
}
</script>
